import React, { Component } from 'react';

import Button from 'components/ui-components/button';
import Modal from 'components/ui-components/modal';

import './styles.less';

class InactiveVideoUpgradeModal extends Component {
  render() {
    const { show, onClose, onUpgradeClick } = this.props;

    return (
      <Modal show={show} dark={true} showClose={false} onDismiss={onClose}>
        <header className="inactive-video-upgrade-upsell-title">
          This video is currently inactive
        </header>
        <div className="inactive-video-upgrade-upsell-content">
          {"You've reached your free video storage limit."}
          <div>To access this video, upgrade to Loom Pro</div>
        </div>
        <div className="inactive-video-upgrade-upsell-actions">
          <Button
            onClicked={onUpgradeClick}
            buttonType="rp-primary-2 premium"
            value="Upgrade to Pro"
          />
          <div
            className="inactive-video-upgrade-upsell-dismiss"
            onClick={onClose}
          >
            Go back to My Videos
          </div>
        </div>
      </Modal>
    );
  }
}

export default InactiveVideoUpgradeModal;
